<template>
  <div class="flex items-center justify-center">
    <svg
      class="twig-loading-animation h-[18px] w-[18px] text-gray-10"
      :class="{
        '!h-8 !w-8': large,
        '!h-14 !w-14': extraLarge,
      }"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        style="opacity: 20%"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        stroke-width="3"
      ></circle>
      <path
        style="opacity: 65%"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>
  </div>
</template>

<script lang="ts" setup>
defineProps({
  large: {
    type: Boolean,
    default: false,
  },
  extraLarge: {
    type: Boolean,
    default: false,
  },
});
</script>

<style lang="scss" scoped>
.twig-loading-animation {
  animation: spin 1s linear infinite;

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
}

.light-theme.twig-layout-background {
  .twig-loading-animation {
    color: var(--c-g500) !important;
    path {
      fill: var(--c-g500) !important;
    }
  }
}
</style>
